import { render, staticRenderFns } from "./tiaolibanner.vue?vue&type=template&id=ff158376&scoped=true&"
import script from "./tiaolibanner.vue?vue&type=script&lang=js&"
export * from "./tiaolibanner.vue?vue&type=script&lang=js&"
import style0 from "./tiaolibanner.vue?vue&type=style&index=0&id=ff158376&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff158376",
  null
  
)

export default component.exports